module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "illustration",
      "src": "images/bird.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FOREWORD BY GARY F. KURUTZ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/preface"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PREFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE WINGS OF THE FUTURE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_vm._v("Beginnings")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("UNDISCIPLINED SQUADS OF EMOTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02"
    }
  }, [_vm._v("Motivations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter03"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE CONSEQUENCE OF FEARFUL BLINDNESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter03"
    }
  }, [_vm._v("Twilight of the Californios")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter04"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“I KNOW IT TO BE NOTHING ELSE”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter04"
    }
  }, [_vm._v("The Sad Tale of James Marshall")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE TALE OF TELEGUAC")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("José Jesús, Native Resistance, and Survival")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“A VAST DEAL OF KNAVERY”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Warnings of Daniel Walton")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“THE EL DORADO OF THEIR MOST SANGUINE WANTS”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Linville Hall, the First Journal")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“A PERFECT USED UP MAN”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Diggings")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“WITH A TAINT OF FRAUD AND A SPICE OF COMEDY”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Claim Salting")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CASTLES IN THE AIR")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quartz Fever")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“DEATH STARED THEM FULL IN THE FACE”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silas Weston and Kelly’s Bar")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“THAT BLIGHTING CURSE”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dissipation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“PLENTY OF JABBERING AND QUARRELING AND SEVERAL FIGHTS”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alfred Doten")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“GAMBLING ON ONE CARD THE FRUIT OF HIS LABOR FOR THE YEAR”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Games of Chance")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“THERE IS NO PERSUASION MORE ESTEEMED FOR MORAL CONDUCT”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jews in the Gold Rush")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“EVERYTHING LOOKS FORLORN AND WRETCHED”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Storms and Floods")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“A WIND TURNED DARK WITH BURNING”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Plague of Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“THE BLUE VAULT OF HEAVEN”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alonzo Delano and the Great Grass Valley Fire of 1855")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("A CRUMBLING KINGDOM")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Collapse of Sutter’s Fort")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE DEVIL’S CHAOS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hydraulic Mining")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“AS HUGE, TO ME, AS AN ELEPHANT”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grizzly Bears")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“A VERY NORMAL CHILDHOOD”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Children and Families")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“THE YEARS HAVE BEEN FULL OF HARDSHIPS”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luzena Stanley Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SHADOW AND LIGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mifflin Wistar Gibbs and Defiance of Discrimination")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("A VAST, GLOWING EMPTY PAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reinvention and the Veritable Squibob")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“EMPEROR OF THESE UNITED STATES”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joshua Norton")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“VERY LITTLE LAW OF ANY KIND”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lawyers and Judges")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“ENJOY IT WITH LUXURIOUS ZEST”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Mason Hutchings")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LETTER OF THE LAW")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter Sheets and the Ten Commandments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“TO THE LAND OF GOLD AND WICKEDNESS”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lorena Lenity Hays Bowmer")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“THE THEATRE OF UNREST”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eliza Farnham")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DRAPED IN A BUTTERFLY ROBE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mariposa County Courthouse")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“CONVULSIVE THROES AND CONFLICTS OF PASSION”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dr. John Morse, the First Historian")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHEESQUATALAWNY")])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Rollin Ridge")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“I AM JOAQUÍN!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Legacy of Joaquín Murieta, the Celebrated California Bandit")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COCK-EYE AND SNOWSHOE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Calhoun Johnson and Jon Torsteinson-Rue, Trailblazers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DUELING DESIGNATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lake Bigler versus Lake Tahoe")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“A GREAT DEAL OF HARD TIMES”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Diary of Joseph Pike")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GUILTY OF DUST AND SIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drinking, Dining, and Desire")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PLAYERS AND PAINTED STAGES")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curiosities and Amusements")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“SO WONDERFUL, SO DANGEROUS, SO MAGNIFICENT A CHAOS”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 1849 California Constitution")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE LEGISLATURE OF A THOUSAND DRINKS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thomas Jefferson Green and the First California Legislature")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“AN ACT FOR THE BETTER REGULATION OF THE MINES AND THE GOVERNMENT OF FOREIGN MINERS”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Foreign Miners’ Tax and the French Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“WE ARE NOT THE DEGRADED RACE YOU WOULD MAKE US”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hab Wa, Long Achick, Noman Asing, and Governor John Bigler")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“THE THEATRE OF SCENES WHICH WE HOPE WILL NEVER BE REPEATED”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vigilantes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GOING UP THE FLUME")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hanging of John Barclay")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“AWFUL CALAMITY”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Explosion of the Steamer "), _c('em', [_vm._v("Belle")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE TERRITORY OF COLORADO")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pico Act of 1859")])]), _vm._v(" "), _c('p', {
    staticClass: "tocl"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE FINAL ACCOUNTING")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocll"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death in the Goldfields")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SOURCES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SOURCES FOR CHAPTER TITLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bm04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ABOUT THE AUTHOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bm05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ABOUT THE SIERRA COLLEGE PRESS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 72
// module chunks = 0